import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=5c0d7a60&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=5c0d7a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d7a60",
  null
  
)

export default component.exports